module.exports = __webpack_public_path__ + "img/shrx.9c38f65e.png";